import { render, staticRenderFns } from "./pro-navigation.vue?vue&type=template&id=32505b4e&scoped=true&lang=html"
import script from "./pro-navigation.vue?vue&type=script&lang=js"
export * from "./pro-navigation.vue?vue&type=script&lang=js"
import style0 from "./pro-navigation.vue?vue&type=style&index=0&id=32505b4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32505b4e",
  null
  
)

export default component.exports